import { Button } from '@/components/ui/button'
import { ErrorState } from '@/components/ui/error-state'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'

/**
 * What a route renders when it throws. The raw message is a stack trace detail, so it stays in dev
 * builds and production users get the support line instead.
 */
export function RouteErrorState({ error, reset }: ErrorComponentProps) {
	const message = import.meta.env.DEV && error instanceof Error ? error.message : undefined

	return (
		<ErrorState
			title='Something went wrong'
			icon={AlertTriangle}
			tone='destructive'
			message={message}
			showSupportEmail={!message}
			actions={
				<Button variant='outline' size='sm' onClick={reset} data-testid='route-error-retry'>
					Try again
				</Button>
			}
		/>
	)
}
